var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-list" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("产品列表")]),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "search-form",
              attrs: { inline: true },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "产品名称" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入产品名称", clearable: "" },
                        model: {
                          value: _vm.formSearch.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formSearch, "name", $$v)
                          },
                          expression: "formSearch.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "产品ID" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入产品ID", clearable: "" },
                        model: {
                          value: _vm.formSearch.productId,
                          callback: function ($$v) {
                            _vm.$set(_vm.formSearch, "productId", $$v)
                          },
                          expression: "formSearch.productId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "产品型号" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入产品型号", clearable: "" },
                        model: {
                          value: _vm.formSearch.productModel,
                          callback: function ($$v) {
                            _vm.$set(_vm.formSearch, "productModel", $$v)
                          },
                          expression: "formSearch.productModel",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "产品类型" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.categoryList,
                          placeholder: "请选择产品类型",
                          "popper-class": "cascader-custom-popper",
                          clearable: "",
                        },
                        on: { change: _vm.handleCategory },
                        model: {
                          value: _vm.categoryValue,
                          callback: function ($$v) {
                            _vm.categoryValue = $$v
                          },
                          expression: "categoryValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 19 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "开发状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formSearch.developStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.formSearch, "developStatus", $$v)
                            },
                            expression: "formSearch.developStatus",
                          },
                        },
                        _vm._l(_vm.developStatusOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "设备类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formSearch.deviceType,
                            callback: function ($$v) {
                              _vm.$set(_vm.formSearch, "deviceType", $$v)
                            },
                            expression: "formSearch.deviceType",
                          },
                        },
                        _vm._l(_vm.deviceTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "产品说明" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入产品说明", clearable: "" },
                        model: {
                          value: _vm.formSearch.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.formSearch, "description", $$v)
                          },
                          expression: "formSearch.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 5 } }, [
                _c(
                  "div",
                  { staticClass: "button-container" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "14" },
                        on: {
                          click: function ($event) {
                            return _vm.queryList("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "14" },
                        on: { click: _vm.resetSearch },
                      },
                      [_vm._v("重置")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled:
                            _vm.rolesCode !== "CUSTOM_ADMIN" &&
                            _vm.rolesCode !== "PRODUCT",
                          type: "primary",
                          size: "14",
                        },
                        on: { click: _vm.createProduct },
                      },
                      [_vm._v("产品创建")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            size: "medium",
            "header-cell-style": { background: "#F5F6F7" },
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "产品信息", width: "300" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "product-info" }, [
                      _c("div", { staticClass: "info-img" }, [
                        _c("img", {
                          attrs: {
                            src: scope.row.icon || _vm.productTypeImg,
                            alt: "",
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "column-content" }, [
                        _c("div", { staticClass: "description" }, [
                          _vm._v(_vm._s(scope.row.name || "-")),
                        ]),
                        _c("div", { staticClass: "details" }, [
                          _vm._v(_vm._s(scope.row.categoryName || "-")),
                        ]),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "设备类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.deviceType[scope.row.deviceType] || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "产品型号" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.productModel || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "产品ID" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.productId || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "通讯协议", "show-overflow-tooltip": "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(scope.row.communicationProtocol || "-")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "配网方式", "show-overflow-tooltip": "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(scope.row.networkDistributeMode || "-")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "开发状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getStatusText(scope.row.developStatus)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "创建时间",
              sortable: "",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.createTime || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "最后更新时间",
              sortable: "",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.updateTime || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "产品说明", "show-overflow-tooltip": "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.description || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.envVar
            ? _c("el-table-column", {
                attrs: { label: "同步状态", width: "120" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "operate" },
                              on: {
                                click: function ($event) {
                                  return _vm.syncData(
                                    scope.row.productId,
                                    "test"
                                  )
                                },
                              },
                            },
                            [_vm._v("测试")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "operate" },
                              on: {
                                click: function ($event) {
                                  return _vm.syncData(
                                    scope.row.productId,
                                    "prod"
                                  )
                                },
                              },
                            },
                            [_vm._v("生产")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1117950669
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "operate" },
                        on: {
                          click: function ($event) {
                            return _vm.jumpDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                    !scope.row.developStatus
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "operate",
                              disabled: _vm.rolesCode !== "CUSTOM_ADMIN",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row.productId)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "page-sizes": [10, 20, 50],
          "current-page": _vm.currentPage,
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }